module.exports = __webpack_public_path__ + "assets/9476ea2abf68156c9b57723b417c78af.json";